import { useTranslation } from 'react-i18next';

export const keyPrefix = 'full_frame';
export const useFullFrameTranslation = () => useTranslation('shared', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    empty: 'Полный кадр отсутствует',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    empty: 'Full frame is missing',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    empty: 'Quadro completo ausente',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    empty: 'Falta el cuadro completo',
  },
}) : {}) as Record<string, unknown>;
